export default __webpack_public_path__ + "static/media/shake-and-roll-dice.a2c23640.mp3";